/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetTiptapVideoStatusQueryVariables = Types.Exact<{
  ref: Types.Scalars['SlugOrID']['input'];
}>;

export type GetTiptapVideoStatusQuery = {
  __typename?: 'Query';
  videoV2?: {
    __typename?: 'VideoV2';
    ref?: string | null;
    globalId: string;
    status: Types.VideoV2Status;
  } | null;
};

export const GetTiptapVideoStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTiptapVideoStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ref' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'videoV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ref' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ref' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ref' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTiptapVideoStatusQuery,
  GetTiptapVideoStatusQueryVariables
>;
